import React, { useEffect, useState, useRef } from 'react';
import DatePick from './DatePick'
import { subDays, startOfMonth, startOfDay } from 'date-fns';
import LocationPicker from '../Helpers/LocationPicker';

export default function DatePicker({ newFilters }) {
    const today = new Date();

    // const getUTCStartOfDay = (date) => new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
    const getUTCEndOfDay = (date) =>
        new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999))

    const didMountRef = useRef(false);
    const [filters, setFilters] = useState(() => ({
        dates: {
            start: startOfDay(subDays(today, 8)),
            end: getUTCEndOfDay(subDays(today, 1)),
        },
    }));

    const updateDates = (d) => {
        const s = d.d1
        const e = d.d2
        setFilters(cur => ({ ...cur, ["dates"]: { start: s ?? filters.dates.start, end: e ?? filters.dates.end } }));
    }

    const updateLocations = (locs) => {
        setFilters({
            "dates": filters.dates,
            "locs": locs,
        })
    }

    useEffect(() => {
        if (didMountRef.current) {
            console.log("SENDING NEW FILTERS")
            newFilters(filters, false);
        } else {
            didMountRef.current = true;
        }
    }, [filters]);

    return (
        <div style={{ display: 'flex', alignContent: 'center', padding: 0 }}>
            <div className='row m-0' style={{ width: '100%', alignItems: 'center' }}>
                <div className='col-3'
                    style={{
                        display: 'flex', alignItems: 'center', paddingRight: 0,
                        justifyContent: 'start', maxWidth: '200px', minWidth: '200px'
                    }}>
                    {/* Custom date picker only for Month - Year */}
                    <DatePick selectDate={(d) => updateDates(d)} defaultDates={{ s: filters?.dates?.start, e: filters?.dates?.end }} />
                </div>
                <div
                    className='col-2'
                    style={{
                        display: 'flex', alignItems: 'center',
                        justifyContent: 'center', paddingLeft: '0', maxWidth: '175px', minWidth: '175px'
                    }} >
                    <LocationPicker filterStores={(locs) => updateLocations(locs)} />
                </div>
            </div>

        </div>
    );
};
